module.exports = __webpack_public_path__ + "img/logo_xr.46f0efa4.png";